import { createContext, useContext, useState, useMemo } from "react";
import { translations } from "@/i18n/publicTranslations";

const PublicLangContext = createContext(null);

export function PublicLangProvider({ children, defaultLang = "es" }) {
  const [lang, setLang] = useState(defaultLang);

  const t = useMemo(() => {
    return (key, vars = {}) => {
      const parts = key.split(".");
      let value = translations[lang];
      for (const p of parts) value = value?.[p];
      if (value == null) return key;
      if (typeof value === "string") {
        return Object.entries(vars).reduce((acc, [k, v]) => acc.replace(`{${k}}`, v), value);
      }
      return value;
    };
  }, [lang]);

  return (
    <PublicLangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </PublicLangContext.Provider>
  );
}

export function usePublicLang() {
  return useContext(PublicLangContext);
}
